import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { DEFAULT_FILTER_CLIENTS_QUERY_PARAMS } from "../api";
import ClientListFilterForm from "../components/forms/ClientListFilterForm";
import ClientListTable from "../components/tables/ClientListTable";
import { ClientFilterPageRequest } from "../types";

export const ClientListContainer = () => {
  const searchParams = useFilterSearchParams<ClientFilterPageRequest>({
    params: [
      "orderBy",
      "orderDirections",
      "types",
      "createdAtMin",
      "createdAtMax",
      "managedByIds",
      "managedByDirectorateIds",
      "partnerAgentDirectorateIds",
      "hasPartnerAgent",
      "partnerAgentIdNumber",
      "hasMobileApp",
      "premiumType",
      "contactClientDaysMin",
      "contactClientDaysMax",
    ],
    defaultQueryParamsObject: DEFAULT_FILTER_CLIENTS_QUERY_PARAMS,
  });

  return (
    <ContentWrapper>
      <ClientListFilterForm searchParams={searchParams} />

      <ClientListTable searchParams={searchParams} />
    </ContentWrapper>
  );
};
